module.exports = __webpack_public_path__ + "static/media/yun-express.675a9200.svg";